module.exports = __webpack_public_path__ + "officialStatic/img/soft11.535d931.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/soft11.png
// module id = 4jBV
// module chunks = 0